import { Component, input, computed, inject, signal } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { VOneSearchComponent } from '@shared-components';
import { STRING_CONSTANTS } from '@shared-constants';
import { Note, NoteType } from '@shared-models';

import { CookieAuthService } from 'src/app/@shared/storage-variables/cookie-auth.service';

import { NoteFormCalculationService } from '../../services/note-form-calculation.service';

@Component({
  selector: 'v-one-related-notes',
  imports: [
    VOneSearchComponent,
    ReactiveFormsModule,
    RouterLink,
    TranslateModule,
  ],
  templateUrl: './related-notes.component.html',
  styleUrls: ['./related-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RelatedNotesComponent {
  private cookieAuthService = inject(CookieAuthService);
  readonly calculationService = inject(NoteFormCalculationService);

  readonly invoiceId = input<number>();
  readonly noteType = input<NoteType>();
  readonly relatedNotes = input<Note[]>();
  readonly totalAccredited = input<number>();

  searchValue = signal<string>('');

  filteredNotes = computed(() => {
    const search = this.searchValue()?.toLowerCase() || '';
    const notes = this.relatedNotes();

    if (!search) return notes;

    return notes?.filter((note) => {
      const noteNumber = this.getNoteNumber(note).toLowerCase();
      const concept = note.concepto.toLowerCase();
      return noteNumber.includes(search) || concept.includes(search);
    });
  });

  companyId = computed(() => {
    const company = this.cookieAuthService.getCompanyObject;
    return company?.Id_company.toString();
  });

  onSearchChange(searchTerm: string): void {
    this.searchValue.set(searchTerm);
  }

  getNoteNumber(note: Note): string {
    const billyNote = note.billyNotes?.[0];

    if (
      billyNote?.note_number &&
      billyNote.note_number !== STRING_CONSTANTS.PENDING
    ) {
      return billyNote.note_number;
    }

    const prefix = note.tipo_nota === 'Credito' ? 'CN' : 'DB';
    return `${prefix}-${note.id_nota}`;
  }

  formatDate(isoDate: string): string {
    const date = new Date(isoDate);
    return date.toLocaleDateString('es-CO', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }

  formatCurrency(amount: number): string {
    return this.calculationService.formatCurrency(amount);
  }
}
